import Header from "components/Header/Header"
import AppButton from "components/StyledComponents/AppButton"
import React, { useEffect, useState } from "react"
import styles from "../../PendingQuestionTable.module.scss"
import { Col, Row } from "react-bootstrap"
import AppSelect from "components/StyledComponents/AppSelect"
import { useDispatch, useSelector } from "react-redux"
import { useDebounce } from "hooks/utils"
import QuestionsList from "./components/QuestionsList"
import { getWeeklyQuestionsBankAction } from "redux/marketing/actions"
import { useHistory } from "react-router-dom"
import AddToChallenge from "./components/AddToChallenge"
import { marketingActions } from "redux/marketing/slice/user"
import UploadQuestionModal from "../BulkUpload/UploadQuestionModal"
import { styled, Tab, useTheme } from "@mui/material"
import { TabContext, TabList } from "@mui/lab"
import { appActions } from "redux/app/slice/app"

const CustomTabList = styled(TabList)(({ theme }) => ({
  "& .MuiTabs-indicator": {
    backgroundColor: theme.palette.secondary.main,
    height: "4px"
  },
  "& .MuiTab-root.Mui-selected": {
    color: theme.palette.secondary.main
  },
  "& .MuiTab-root": {
    textTransform: "none",
    padding: "20px 28px 20px 28px"
  },
  "& .MuiTabs-scroller ": {
    marginLeft: "12px"
  }
}))

const WeeklyQuestionBank = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const theme = useTheme()
  const [page, setPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [filter, setFilter] = useState("ALL")
  const [filteredResults, setFilteredResults] = useState([])
  const [searchValue, setSearchValue] = useState("")
  const [questionList, setQuestionList] = useState([])
  const [questionCategoryCount, setQuestionCategoryCount] = useState([])
  const debouncedSearchTerm = useDebounce(searchValue, 500)
  const [filterQuestion, setFilterQuestion] = useState("ALL")
  const [openChallengeDialog, setOpenChallengeDialog] = useState(false)
  const [challengeData, setChallengeData] = useState({})
  const [modalOpen, setModalOpen] = useState(false)
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false)
  const [selectedQuestions, setSelectedQuestions] = useState([])

  const { userRestaurant } = useSelector((store) => store.user)
  const { rank, category } = useSelector((store) => store?.app?.filters || [])
  const { categoryCount } = useSelector((state) => state?.learningDevelopment)
  const { weeklyQuestionBankData } = useSelector((state) => state?.marketing)
  const [activeTab, setActiveTab] = useState("question_bank")

  const handleChange = (event, newValue) => {
    setActiveTab(newValue)
  }

  const classes = {
    btnDelete: {
      color: theme.palette.red.main,
      borderColor: theme.palette.red.main,
      paddingLeft: "30px",
      paddingRight: "30px",
      marginRight: "16px",
      "&:hover": {
        borderColor: theme.palette.red.main,
        backgroundColor: theme.palette.background.default
      }
    }
  }

  const filters = [
    {
      label: "All",
      value: "ALL"
    },
    {
      label: userRestaurant?.name || "Scarpetta",
      value: userRestaurant?.name || "scarpetta"
    },
    {
      label: "Vantero AI",
      value: "gamification"
    }
  ]

  const handleFilter = (event) => {
    setFilter(event.target.value)
  }

  const handleAddChallengeDialogClose = () => {
    setOpenChallengeDialog(false)
  }

  const handleAddToChallenge = (data) => {
    setOpenChallengeDialog(true)
    setChallengeData(data)
  }

  function filterResults(result, selectedRank, selectedCategory, searchTerm) {
    let filteredResults = result

    // Check if search term is provided
    if (searchTerm.trim() !== "") {
      const searchRegex = new RegExp(searchTerm.trim().replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "i")
      filteredResults = filteredResults?.filter(
        (item) =>
          item.answer.some((answer) => searchRegex.test(answer.answer)) ||
          searchRegex.test(item.title) ||
          searchRegex.test(item.food_name) ||
          searchRegex.test(item.filter_category)
      )
    }

    // Check if selected ranks and categories are provided
    if (selectedRank.length > 0) {
      filteredResults = filteredResults?.filter((item) => selectedRank.includes(item.rank))
    }

    if (selectedCategory.length > 0) {
      filteredResults = filteredResults?.filter((item) =>
        selectedCategory.includes(item.filter_category?.toLowerCase())
      )
    }

    return filteredResults
  }

  const handleAddQuestion = () => {
    dispatch(marketingActions.setTastingNotesImages([]))
    history.push("/learning_development/dashboard/weekly-question-bank/add-questions")
  }

  const handleClose = () => {
    setModalOpen(false)
  }

  const toggleDeletePopup = () => {
    setIsDeletePopupOpen((prev) => !prev)
  }

  const handleSelectedQuestionsChange = (selected) => {
    setSelectedQuestions(selected)
  }

  const itemsPerPage = 12
  useEffect(() => {
    const filteredResults = filterResults(
      weeklyQuestionBankData,
      rank,
      category,
      debouncedSearchTerm
    )

    const totalItems = filteredResults?.length || 0
    const totalPages = Math.ceil(totalItems / itemsPerPage)
    setPage(totalPages)
    const startIndex = (currentPage - 1) * itemsPerPage
    const endIndex = Math.min(startIndex + itemsPerPage, totalItems)
    const questionList = filteredResults?.slice(startIndex, endIndex)
    setFilteredResults(filteredResults)
    setQuestionList(questionList)
  }, [weeklyQuestionBankData, rank, category, debouncedSearchTerm, currentPage])

  useEffect(() => {
    setCurrentPage(1)
  }, [rank, category, debouncedSearchTerm])

  useEffect(() => {
    const newData = [
      {
        title: "All",
        category: "ALL",
        count: categoryCount?.total_count
      }
    ]

    const categoryOrder = ["Food", "Beverage", "Wine Region", "Special", "VIP"]

    categoryOrder?.forEach((categoryName) => {
      const categoryData = categoryCount?.categories_data?.find(
        (category) => category?.name === categoryName
      )
      categoryData?.sub_category?.forEach((subCategory) => {
        newData?.push({
          title: subCategory?.sub_category,
          category: categoryName,
          count: subCategory?.count
        })
      })
    })
    setQuestionCategoryCount(newData)
  }, [categoryCount])

  useEffect(() => {
    dispatch(
      getWeeklyQuestionsBankAction({
        platform: filter,
        question_used: filterQuestion,
        archived: activeTab === "archived" ? "True" : "False"
      })
    )
  }, [filter, filterQuestion, activeTab])

  useEffect(() => {
    dispatch(appActions.initFilters())
    document.title = "Weekly Challenge Question Bank"
  }, [])

  return (
    <>
      {openChallengeDialog && (
        <AddToChallenge onClose={handleAddChallengeDialogClose} data={challengeData} />
      )}
      <UploadQuestionModal open={modalOpen} onClose={handleClose} />
      <Header title="Weekly Challenge Question Bank">
        {selectedQuestions?.length > 0 && (
          <AppButton variant="contained" styles={classes.btnDelete} onClick={toggleDeletePopup}>
            Delete All
          </AppButton>
        )}
        <AppButton variant="contained" onClick={() => setModalOpen(true)} sx={{ mr: 2 }}>
          + Bulk Upload
        </AppButton>
        <AppButton className={styles.addButton} onClick={handleAddQuestion}>
          Add Questions
        </AppButton>
      </Header>
      <Row className="d-flex">
        <Col lg="2">
          <AppSelect menuItems={filters} value={filter} onChange={handleFilter} />
        </Col>
      </Row>
      <Header title={"Question Bank"} count={filteredResults?.length} back={false} />

      <TabContext value={activeTab}>
        <Col>
          <CustomTabList onChange={handleChange} sx={{ overflow: "auto" }}>
            <Tab label="Weekly Question bank" value="question_bank" />
            <Tab label="Archived Question bank" value="archived" />
          </CustomTabList>
        </Col>
      </TabContext>

      <QuestionsList
        title={"Question Bank"}
        questions={questionList}
        pages={page}
        isEditable={true}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        isWeeklyChallenge={true}
        handleAddToChallenge={handleAddToChallenge}
        isDelete={true}
        questionFilter={true}
        setFilterQuestion={setFilterQuestion}
        filterQuestion={filterQuestion}
        filterOptions={sortOption}
        itemsPerPage={itemsPerPage}
        platform={filter}
        questionCount={filteredResults?.length}
        categoryCount={true}
        showRank={true}
        RankOpt={RankOpt}
        questionCategoryCount={questionCategoryCount}
        isCMSAutoSuggest={true}
        searchValue={searchValue}
        activeTab={activeTab}
        setSearchValue={setSearchValue}
        isBulkDeletePopupOpen={isDeletePopupOpen}
        setIsBulkDeletePopupOpen={setIsDeletePopupOpen}
        onSelectionChange={handleSelectedQuestionsChange}
      />
    </>
  )
}

export default WeeklyQuestionBank

const sortOption = [
  {
    label: "All",
    value: "ALL"
  },
  {
    label: "In use",
    value: "true"
  },
  {
    label: "Not In Use",
    value: "false"
  },
  {
    label: "Flagged",
    value: "flagged"
  }
]

const RankOpt = [1, 2, 3]
